<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb :breadCrumbIteams="breadCrumbIteams"></bread-crumb>
    </div>

    <AiSettingsPanel />
  </div>
</template>

<script>
import AiSettingsPanel from "./AiSettingsPanel.vue";

/**
 * The settings as a page of their own, at `/ai/settings`.
 *
 * The everyday route in is the gear in the workspace's history rail, which opens the
 * same panel in a modal without leaving the conversation. This page exists so the
 * screen is still linkable — a runbook step or a message to a colleague can point at a
 * URL, which a modal inside another screen cannot offer.
 */
export default {
  name: "AiSettingsComponent",

  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    AiSettingsPanel,
  },

  data() {
    return {
      breadCrumbIteams: [
        { title: "Home", links: "/home" },
        { title: "AI Workspace Settings", isbold: true },
      ],
    };
  },
};
</script>
